import { render, staticRenderFns } from "./AttachmentTemplatesDialog.vue?vue&type=template&id=750ba94b&scoped=true&"
import script from "./AttachmentTemplatesDialog.vue?vue&type=script&lang=ts&"
export * from "./AttachmentTemplatesDialog.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "750ba94b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/jonas/Projects/Risolto/operator-fe/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('750ba94b')) {
      api.createRecord('750ba94b', component.options)
    } else {
      api.reload('750ba94b', component.options)
    }
    module.hot.accept("./AttachmentTemplatesDialog.vue?vue&type=template&id=750ba94b&scoped=true&", function () {
      api.rerender('750ba94b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/_dialogs/AttachmentTemplatesDialog.vue"
export default component.exports